export default {"src":"/_next/static/media/Handy-Nudeln.21f19735.svg","height":737,"width":709,"blurWidth":0,"blurHeight":0};